import { all, put, select, takeLatest } from 'redux-saga/effects';
import { HomeActionTypes } from '@store/home-screen/home-action';
import { AlertActionType } from '@store/alert/alert-action';
import generalSearchApi from '@api/home-screen/general-search';
import { homeStore } from './home-store';
import holidayListApi from '@api/calendar/holiday-list';
import getDictionary from '@dictionaries-client';

function* loadUserListDataWatcher() {
  const { locale } = yield select(homeStore);
  const { api: { home: { messages } } } = getDictionary(locale);
  try {
    const { searchValue } = yield select(homeStore);

    const response: { data: {products: Array<any>, users: Array<any>, posts: Array<any>} } = yield generalSearchApi({ searchQuery: searchValue, cache: 'no-cache' });

    yield put({
      type: HomeActionTypes.SET_SEARCH_RESULTS,
      data: response?.data,
    });
  } catch (error : any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || messages.default,
      severity: 'danger',
    });
  }
}

function* getHolidayListWatcher() {
  const { locale } = yield select(homeStore);
  const { api: { home: { messages } } } = getDictionary(locale);
  try {
    const response: { data: Array<string>} = yield holidayListApi({});
    yield put({
      type: HomeActionTypes.SET_CALENDAR_HOLIDAY_LIST,
      data: {
        list: response?.data,
      },
    });
  } catch (error) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: messages.holiday_list_error,
      severity: 'danger',
    });
  }
}

function* homeMiddleware() {
  yield all([
    takeLatest(HomeActionTypes.GET_SEARCH_RESULTS, loadUserListDataWatcher),
    takeLatest(HomeActionTypes.GET_CALENDAR_HOLIDAY_LIST, getHolidayListWatcher),
  ]);
}

export default homeMiddleware;
